// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA7B70JA0I-ADkMLPe3spT1nDP-yQXxQcM",
    authDomain: "nuresp-web.firebaseapp.com",
    databaseURL: "https://nuresp-web.firebaseio.com",
    projectId: "nuresp-web",
    storageBucket: "nuresp-web.appspot.com",
    messagingSenderId: "126670375094"
  }
};



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/environments/environment.ts